export default __webpack_public_path__ + "static/media/hk.296b806e.svg";